export const ABOUT_PAGE = "/about";
export const CONTACT_PAGE = "/contact";
export const PROJECT_PAGE = "/portfolio";
export const LIFE_PAGE = "/life";
export const TESTIMONIALS_PAGE = "/testimonials";
export const PRODUCTION = "production";
export const RESOURCES_PAGE = "/resources";
